import { CellProps } from 'react-table';
import AutocompleteV2 from '../../../../component/AutocompleteObjectV2';
import EditableCell from './EditableCell';
import useDepartmentOptions from './hooks/useDepartmentOptions';
import { DEPARTMENT_CONFIG_TYPE } from '../../../../utils/Constant';

const Select = ({ setEnableEditing, updateRowData, row }: any) => {
	const rowData = row.original;

	const fulfillDepartmentDefault = rowData?.attributes?.deptLaboratoryCode
		? [
				{
					name: rowData?.attributes?.deptLaboratoryName,
					value: rowData?.attributes?.deptLaboratoryCode,
				},
		  ]
		: [];

	const fulfillDepartmentConfigByTerm = rowData?.attributes?.deptLaboratories
		? JSON.parse(rowData?.attributes?.deptLaboratories).map((item: any) => ({
				name: item?.name,
				value: item?.code,
		  }))
		: [];

	const currentValue = rowData?.fulfillDeptCode
		? [
				{
					name: rowData?.fulfillDeptName,
					value: rowData?.fulfillDeptCode,
				},
		  ]
		: fulfillDepartmentDefault;

	const { departmentOptions } = useDepartmentOptions({
		defaultOptions: [
			...currentValue,
			...fulfillDepartmentDefault,
			...fulfillDepartmentConfigByTerm,
		],
		departmentConfigType: DEPARTMENT_CONFIG_TYPE.FULFILL,
	});

	return (
		<AutocompleteV2
			autoFocus
			options={departmentOptions}
			value={currentValue}
			name="fulfillDepartment"
			onChange={(selectedOption: any) => {
				updateRowData(row.index, (value: any) => ({
					...value,
					fulfillDeptCode: selectedOption?.value,
					fulfillDeptName: selectedOption?.name,
				}));
				setEnableEditing(false);
			}}
			onBlur={() => {
				setEnableEditing(false);
			}}
			className="autocomplete-custom-tiep-nhan radius spaces width-100 h-25"
			isClearable={false}
		/>
	);
};

const FulFillDepartmentCell = ({ row, tableOptions }: CellProps<any>) => {
	const { updateRowData } = tableOptions;
	const rowData = row.original;
	const textValue = rowData?.fulfillDeptName || rowData?.attributes?.deptLaboratoryName;

	return (
		<EditableCell
			editComponent={(props: any) => (
				<Select row={row} updateRowData={updateRowData} {...props} />
			)}
			textValue={textValue}
		/>
	);
};

export default FulFillDepartmentCell;
